import { TranslationsType } from './types';

export const TRANSLATIONS: TranslationsType = {
  actions: 'Actions',
  address: 'Adresse',
  adminSettings: "Paramètres d'administration",
  allergenEnum: {
    celery: 'Céleri',
    none: 'Aucun allergène',
    crustaceans: 'Crustacés',
    eggs: 'Œufs',
    fish: 'Poisson',
    gluten: 'Gluten',
    lupin: 'Lupin',
    milk: 'Lait',
    molluscs: 'Mollusques',
    mustard: 'Moutarde',
    nuts: 'Noix',
    peanuts: 'Cacahuètes',
    sesame: 'Sésame',
    soya: 'Soja',
    sulphurDioxide: 'Dioxyde de soufre',
  },
  allergens: 'Allergènes',
  amountOfBoxes: 'Quantité de boîtes',
  'api-keys': 'Clés API',
  apiKeysPage: {
    apiKeyCreated: 'La clé Api a été créée',
    apiKeyDeleted: 'La clé Api a été supprimée',
    copyToken: 'Copier le jeton',
    create: 'Clé API créée',
    tokenCopied: 'Jeton copié',
    tokenHasBeenCopied: "Le jeton a été copié et peut être collé dans l'application tierce",
  },
  areYouSure: 'Etes vous sûr?',
  authentication: 'Authentification',
  authenticationType: "Type d'authentification",
  automaticallySendNotification: 'Envoyer des notifications automatiquement',
  available: 'Disponible',
  box: 'Compartiment',
  boxes: 'Compartiments',
  brandColor: 'Couleur de la marque',
  brandingSettings: 'Paramètres de la marque',
  cancel: 'Annuler',
  canUseMealVouchers: 'Peut utiliser des chèques-repas?',
  changePasswordPage: {
    confirmPassword: 'Confirmer le mot de passe',
    disclaimer:
      "Pour une sécurité améliorée, nous vous recommandons fortement d'utiliser la connexion par e-mail ou SSO au lieu de configurer un mot de passe.",
    enablePasswordLogin: 'Activer la connexion par mot de passe',
    password: 'Mot de passe',
    passwordsNotEqual: 'Password and confirm password should be the same',
    passwordTooShort: 'Le mot de passe est trop court',
    title: 'Modifier le mot de passe',
  },
  city: 'Ville',
  close: 'Fermer',
  connectionStatus: 'Statut de connexion',
  contactDetails: 'Coordonnées',
  content: 'Contenu',
  countries: {
    be: 'Belgique',
    fr: 'France',
    nl: 'Pays-Bas',
  },
  country: 'Pays',
  createdAt: 'Créé à',
  currentStatus: 'Statut actuel',
  customer: 'Client',
  customers: 'Clients',
  customersPage: {
    couldNotDelete: 'Impossible de supprimé le client',
    create: 'Créer un client',
    customerCreated: 'Le client a été créé avec succès',
    customerRemoved: 'Le client a été retiré',
    customerUpdated: 'Mise à jour du client réussie',
    invalidPincode: 'Le code PIN doit comporter 5 chiffres',
    noContactInformation: 'Pas de coordonnées',
    noContactInformationDescription:
      "vous n'avez pas fourni de coordonnées pour le client {firstName}, nous ne pourrons donc pas envoyer de notifications pour cette raison.",
    notFound: 'Client introuvable',
    searchCustomer: 'Rechercher un client...',
  },
  date: {
    lastMonth: 'Le mois dernier',
    lastWeek: 'La semaine dernière',
    nextMonth: 'Le mois prochain',
    nextWeek: 'La semaine prochaine',
    today: "Aujourd'hui",
    tomorrow: 'Demain',
    yesterday: 'Hier',
  },
  delete: 'Supprimer',
  description: 'Description',
  details: 'Détails',
  deviceId: "Numéro d'identification de l'appareil",
  deviceLogs: {
    title: "Journaux de l'Appareil",
  },
  discount: 'Remise',
  discountPercentage: 'Pourcentage de remise',
  documentation: 'Documentation',
  duration: {
    seconds: 'secondes',
    minutes: 'minutes',
    hours: 'heures',
    unit: 'Unité',
  },
  edit: 'Modifier',
  email: 'Adresse e-mail',
  emailNote: 'Note e-mail',
  emailNotification: 'Notification par e-mail',
  errors: {
    serverError: "Une erreur provenant du serveur s'est produite",
  },
  export: 'Exporter',
  externalId: 'ID externe',
  extraInformation: 'Informations supplémentaires',
  customerNote: 'Remarque',
  customerNotePlaceholder: 'Remarque pour le client (visible dans l’e-mail)…',
  firmwareVersion: 'Version du microprogramme',
  firstName: 'Prénom',
  hasNutritionalInformation: "Contient l'information des valeurs nutritionnelles",
  id: 'Identifiant',
  image: 'Image',
  import: 'Importer',
  includedProducts: 'Produits inclus',
  interval: 'Intervalle',
  isBetaTester: 'Recevoir le microprogramme bêta ?',
  isInActive: 'Est inactif',
  isVendingReservation: 'Est-ce pour Woyti?',
  isVirtualVendingEnabled: 'Activer Woyti',
  language: 'Langue',
  languageEnum: {
    de: 'Allemand',
    en: 'Anglais',
    fr: 'Français',
    nl: 'Néerlandais',
  },
  lastErrorAt: 'Dernière erreur',
  lastErrorMessage: "Dernier message d'erreur",
  lastName: 'Nom de famille',
  lastSeenAt: 'Dernière consultation',
  lastStateUpdate: 'Dernière mise à jour du statut',
  linkedReservations: 'Réservations liées',
  locker: 'Casier',
  lockers: 'Casiers',
  lockersPage: {
    boxOpened: 'La boîte a été ouverte',
    connectALocker: 'Connecter un casier',
    couldNotDelete: 'Impossible de supprimer le casier',
    couldNotOpenBox: "La boîte n'a pas pu être ouverte",
    created: 'Le casier a été créé',
    disableLockdown: 'Désactiver le blocage',
    disableLockdownConfirm:
      'Êtes-vous sûr de vouloir désactiver le verrouillage pour ce locker? Cela est généralement dû à une erreur technique de température, veuillez vous assurer que tout aliment stocké à la mauvaise température est éliminé.',
    enableLockdown: 'Désactiver le verrouillage',
    enableLockdownConfirm:
      'Êtes-vous sûr de vouloir activer le verrouillage pour ce verrou ? Les clients ne seront pas en mesure de récupérer leurs commandes tant que cette option est activée.',
    lockdownMessage:
      'Le box était bloquée à cause de problèmes de température. Recherchez la cause et vérifiez la qualité des produits contenus dans le box. Cliquez sur ‘désactiver le blocage’ au niveau des casiers pour autoriser à nouveau les collectes.',
    hasBeenModified: 'le casier a été modifié',
    lockdownStatusUpdated: 'Le statut de verrouillage a été mis à jour',
    notFound: 'Casier introuvable',
    noLockersFound: 'Aucun casier trouvé',
    openAll: 'Ouvrez toutes les compartiments',
    openAvailableBoxes: 'Ouvrir les compartiments disponibles',
    openMainDoor: 'Ouvrir la porte principale',
    temperatureLockdownHint: 'Cliquez pour activer/désactiver le blocage',
    settings: 'Paramètres du casier',
    lastOpenedAt: 'Dernière ouverture le',
    lastClosedAt: 'Dernière fermeture le',
    openForDuration: '{duration} ouverte',
    closedForDuration: '{duration} fermée',
    durationSeconds: '{n} s',
    durationMinutes: '{n} min',
    durationHours: '{n} h',
    durationDays: '{n} j',
    openBox: 'Ouvrir le compartiment',
    mainDoorLastOpenedAt: 'Porte principale dernière ouverture',
    mainDoorLastClosedAt: 'Porte principale dernière fermeture',
    listView: 'Liste',
    overviewView: 'Aperçu',
    switchToListView: 'Passer à la vue liste',
    switchToOverviewView: "Passer à l'aperçu",
    overviewTruncated: '{shown} casiers sur {total} affichés',
    offline: 'Hors ligne',
    mainDoorIsOpen: 'La porte principale est ouverte',
    mainDoorIsClosed: 'La porte principale est fermée',
    mainDoorOpenedAt: 'Porte principale ouverte à {time}',
    mainDoorClosedAt: 'Porte principale fermée à {time}',
    mainDoorOpenForDuration: '{duration} ouverte',
    mainDoorClosedForDuration: '{duration} fermée',
    block: 'Bloquer',
    temperatureCheck: {
      pageTitle: 'Contrôle température',
      title: 'Température pour l’AFSCA — {name}',
      intro:
        'Aperçu quotidien de la température du mois passé, à présenter à l’AFSCA. Les épisodes de plus de 30 minutes au-dessus de 6°C sont mis en évidence. Entre les points de mesure épars, la dernière valeur est prolongée.',
      backToLocker: 'Retour au casier',
      period: 'Période',
      currentTemperature: 'Température actuelle',
      longEpisodesTotal: 'Épisodes ≥ {minutes} min au-dessus de {temp}°C',
      minutesAboveTotal: 'Minutes totales au-dessus de {temp}°C',
      dailyMetrics: 'Indicateurs quotidiens',
      episodeList: 'Épisodes longs',
      date: 'Date',
      min: 'Min',
      max: 'Max',
      avg: 'Moy.',
      minutesAbove: 'Minutes > {temp}°C',
      longEpisodes: 'Épisodes ≥ 30 min',
      truncatedWarning: 'Tous les relevés de température de cette période n’ont pas pu être chargés. Les indicateurs peuvent être incomplets.',
    },
    boxLog: {
      title: '{lockerName} - case {boxId}',
      lockerTitle: '{lockerName}',
      subtitle: 'Réservations, notifications et ouvertures pour cette case.',
      lockerSubtitle: 'Réservations, notifications et ouvertures pour ce casier.',
      empty: 'Aucun événement trouvé.',
      loadMore: 'Charger plus',
      viewLog: 'Journal',
      openLogs: 'Ouvrir le journal',
      boxLabel: 'Case {boxId}',
      stillOpenAfter: 'toujours ouvert après {duration}',
      closedAfter: 'fermé après {duration}',
      openedWithPin: 'Case ouverte avec le PIN',
      openedWithOverwrite: 'Case ouverte avec le code overwrite',
      openedByUser: 'Case ouverte par {name}',
      openedViaDashboard: 'Case ouverte via le dashboard',
      mainDoorOpened: 'Porte principale ouverte',
      mainDoorOpenedByUser: 'Porte principale ouverte par {name}',
      openedRemote: 'Case ouverte via retrait distant',
      openedRemoteEmail: 'Case ouverte via lien e-mail',
      openedRemoteSms: 'Case ouverte via SMS',
      actorBoxReserved: 'Compartiment réservé',
      actorWoytiStocked: 'Woyti préparé',
      actorBoxCancelled: 'Réservation annulée',
      actorBoxCompleted: 'Réservation terminée',
      actorBoxMerged: 'Compartiment fusionné',
      mergedFromInto: 'de #{from} vers #{into}',
      mergedFrom: 'de #{from}',
      mergedAlsoFrom: 'aussi #{reservations}',
      actorPincodeSentEmail: 'Code PIN envoyé par e-mail',
      actorPincodeSentSms: 'Code PIN envoyé par SMS',
      actorEmailSent: 'Demande de paiement envoyée par e-mail',
      actorSmsSent: 'Demande de paiement envoyée par SMS',
      actorKioskPaid: 'Payé via kiosque',
      actorIncorrectPincode: 'Code PIN incorrect',
      reservationPrefixNameOnly: 'pour {customerName}',
      reservedBy: 'par {name}',
      cancelledBy: 'par {name}',
      completedBy: 'par {name}',
      notificationTo: 'à {recipients}',
      lockerNotFound: 'Casier introuvable pour ce lien de journal',
    },
    unblock: 'Débloquer',
  },
  lockerTemperatureType: {
    NotCooled: 'Non réfrigéré',
    Refrigerated: 'Réfrigéré',
    RoomTemperature: 'Température de la pièce',
    Heated: 'Chauffé',
  },
  lockStatusses: {
    closed: 'Fermé',
    open: 'Ouvert',
    opened: 'Ouvert',
  },
  log: 'Registre',
  logo: 'Logo',
  LogOperationEnum: {
    Created: 'Créé',
    Deleted: 'Supprimé',
    Error: 'Erreur',
    Opened: 'Ouvert',
    Received: 'Reçu',
    Sent: 'Envoyé',
    Updated: 'Modifié',
  },
  logs: 'Registres',
  logsPage: {
    notFound: 'Registre non trouvé',
    operationFilter: 'Trier par opération',
    severityFilter: 'Trier par sévérité',
    typeFilter: 'Trier par type',
  },
  mainDoor: "Porte d'entrée",
  message: 'Message',
  month: 'Mois',
  minimumAmount: 'Montant minimum',
  name: 'Nom',
  newNotifications: 'Vous avez de nouvelles notifications',
  next: 'Suivant',
  noAutoComplete: 'Réservation rectifiée (ne pas remplir automatiquement)',
  noBoxReserved: 'Aucun casier réservé, le code postal du client ne peut servir que si un casier a été réservé',
  notification: 'Notification',
  notifications: 'Notifications',
  number: 'Numéro',
  nutritionalInformation: 'Valeurs nutritionnelles',
  nutritionalInformationItems: {
    addedSugars: 'Sucres ajoutés',
    carbohydrate: 'Glucides',
    cholesterol: 'Cholestérol',
    energy: 'Valeur énergétique (en kcal)',
    fat: 'Matières grasses',
    fiber: 'Fibres',
    protein: 'Protéines',
    salt: 'Sel',
    saturatedFat: 'dont graisses saturées',
    sugars: 'Sucres',
  },
  operation: 'Opération',
  order: 'Commande',
  orderAmount: 'Montant total de la commande',
  joynPoints: 'Joyn points',
  orderConfirmationEmailTemplate: 'E-mail de confirmation de commande',
  orderLines: 'Articles commandés',
  orderNumber: 'Numéro de commande',
  orders: 'Commandes',
  ordersPage: {
    cancelled: 'Annulé',
    completed: 'Terminé',
    confirmationSent: 'Confirmation de commande envoyée',
    create: 'Créer la commande',
    notFound: 'Commande non trouvée',
    orderCanceled: 'La commande a été annulée',
    orderChanged: 'Commande modifiée avec succès',
    orderStatus: 'Statut de la commande',
    omzet: "Chiffre d'affaires",
    searchOrder: 'Trouver une commande...',
  },
  printHub: {
    printer: 'Printer',
    notConfigured: 'No label printer configured for this shop.',
    setupCta: 'Set up print hub',
    setupHint: 'Download the print hub, run Setup… in the tray, then claim a printer for this shop.',
    online: 'Print hub online',
    offline: 'Print hub offline',
    hub: 'Hub',
    lastSeen: 'Last heartbeat',
    incompleteCount: 'Incomplete prints',
    failedCount: 'Failed prints (24h)',
    recentAvgDelay: 'Recent avg. print delay',
    noRecentPrints: 'No recent completed prints',
    download: 'Download print hub',
    downloadWindows: 'Windows',
    downloadIntelMac: 'Mac Intel',
    downloadAppleSilicon: 'Apple silicon',
    macosInstallHint:
      'Glissez l’app dans Applications, puis ouvrez-la la première fois via clic droit → Ouvrir (le double-clic peut être bloqué).',
    disconnect: 'Disconnect printer',
    testPrint: 'Test print',
    testPrintQueued: 'Test print sent to the hub.',
    testPrintFailed: 'Could not queue test print',
    claimTitle: 'Connect print hub',
    claimExpiredTitle: 'Link expired',
    claimExpiredBody: 'Open Setup… again from the print hub tray, then retry.',
    claimSuccessTitle: 'Printer connected',
    claimSuccessBody: 'Paid app orders for this shop will print automatically.',
    claimConfirm: 'Connect printer',
    claimFailed: 'Could not connect print hub',
    selectShop: 'Shop',
    searchShop: 'Rechercher un magasin…',
    selectPrinter: 'Printer',
    defaultPrinter: 'par défaut',
    noPrintersYet: 'No printers reported yet. Keep the hub running, then refresh this page.',
    backToOrders: 'Back to orders',
    settings: 'Hub settings',
    pollInterval: 'Poll interval',
    maxPrintAttempts: 'Max print attempts',
    startedJobTimeout: 'Stuck job timeout',
    saveSettings: 'Save settings',
    settingsSaved: 'Settings saved. The hub picks them up on the next poll.',
    settingsSaveFailed: 'Could not save settings',
    layoutSettings: 'Mise en page ticket / étiquette',
    paperWidth: 'Largeur papier',
    font: 'Police',
    charsPerLine: 'Caractères par ligne',
    useSuggested: 'Utiliser la suggestion',
    labelSize: 'Taille d’étiquette',
    dpi: 'DPI',
    preview: 'Aperçu',
    previewLoading: 'Génération de l’aperçu…',
    previewUnavailable: 'Aperçu indisponible',
    format: 'Format',
    manualZpl: 'Imprimante ZPL par IP (zpl://…)',
    saveLayout: 'Enregistrer la mise en page',
    layoutSaved: 'Mise en page enregistrée. Les prochains tickets l’utilisent tout de suite.',
    layoutSaveFailed: 'Impossible d’enregistrer la mise en page',
    trayUpdateRequired: 'Ce print hub doit être mis à jour avant d’imprimer.',
    trayUpdateLink: 'Télécharger la mise à jour',
  },
  refund: {
    title: 'Refund',
    minimumRefundError: 'Should refund at least 1 cent',
    maximumRefundError: 'Cannot refund more than the order total',
    amount: 'Refund amount',
    description: 'Refund description',
    descriptionPlaceholder: 'Return of goods #125',
    confirm: 'Confirm refund',
    success: 'Refund successfully sent',
    failed: 'Could not refund order',
  },
  orderStatusEnum: {
    Canceled: 'Annulée',
    PaymentCanceled: 'Payment Canceled',
    Created: 'Créée',
    Expired: 'Expirée',
    PaymentExpired: 'Payment Expired',
    Paid: 'Payée',
    Refunded: 'Remboursée',
  },
  organisation: 'Organisation',
  organisationScreen: {
    companyName: "Nom de l'entreprise",
    couldNotRemove: "Impossible de supprimer l'organisation",
    create: 'Créer une organisation',
    created: "L'organisation a été créée",
    registrationNumber: "Numéro de l'entreprise",
    registrationNumberRequired: "Le numéro de l'entreprise est requis",
    search: 'Rechercher une organisation',
    selectionHeading: 'Organisations',
  },
  origin: 'Origine',
  overviewScreen: {
    inLocker: 'Casier',
    inQueue: "File d'attente",
    someDevicesAreOffline:
      'Les dispositifs « {devices} » sont hors ligne, ce qui peut avoir pour conséquence que certaines réserves ne soient pas synchronisées avec le dispositif.',
    title: "Vue d'ensemble",
    vendingTag: 'Woyti',
    unboxedTag: 'Woyti sans box',
    hiddenTag: 'Caché',
    validUntilPassedTag: 'Date dépassée',
    lockersInLockdown:
      'Les casiers "{lockers}" sont en confinement, cela est probablement dû à un problème de température, allez à la page des casiers pour plus de détails.',
    woytiOrdersToNotify: '{clients} notifications peuvent etre envoyees pour {amount} nouvelles reservations Woyti.',
    woytiOrdersToPublish: '{amount} nouvelles reservations Woyti peuvent etre publiees. Aucune notification ne sera envoyee.',
    markReservationAsCollectedSuccess: 'Réservation marquée comme retirée.',
    markReservationAsCollectedFailed: 'Impossible de marquer la réservation comme retirée.',
    empty: 'Aucune réservation',
  },
  overwriteCodeScreen: {
    changedSuccess: 'Code de remplacement modifié avec succès',
    confirmRemoval: 'Êtes-vous sûr de vouloir supprimer ce code de remplacement ?',
    create: 'Créer le code de remplacement',
    created: 'Le code de remplacement a été créé',
    editTitle: 'Modifier le code de remplacement',
    invalidPincode: 'Le code PIN doit comporter 6 chiffres',
    notFound: 'Code de remplacement non trouvé',
    overviewTitle: 'Codes de remplacement',
    removedSuccess: 'Le code de remplacement {name} a été supprimé',
    search: 'Trouver un code de remplacement...',
  },
  pageHeader: {
    organisationSelection: "Sélection de l'organisation",
    shopSelection: 'Sélection du magasin',
  },
  paidAt: 'Payé à',
  paymentGateway: 'Passerelle de paiement',
  paymentGatewayEnum: {
    Bancontact: 'Bancontact / Worldline',
    MollieOrders: 'Mollie Orders',
    MolliePayments: 'Mollie Payments',
    Sandbox: 'Sandbox',
    Stripe: 'Stripe',
  },
  paymentMethod: 'Moyen de paiement',
  molliePayments: 'Paiements Mollie',
  mollieOrderId: 'Commande Mollie',
  mollieCancelable: 'Annulable',
  mollieNotCancelable: 'Non annulable',
  mollieTestMode: 'Mode test',
  mollieCheckoutLink: 'Lien de paiement',
  password: 'Mot de passe',
  passwordValidation: {
    length: 'Minimum 8 caractères',
    lowercase: 'Contient des minuscules',
    numbers: 'Contient des chiffres',
    uppercase: 'Contient des majuscules',
  },
  phonenumber: 'Numéro de téléphone',
  pickupCode: 'Code de retrait',
  pickupDate: 'Date de retrait',
  pickupTime: 'Heure de retrait',
  pincode: 'Code PIN',
  previous: 'Précédent',
  price: 'Prix',
  pricePerType: 'Prix par {type}',
  product: 'Produit',
  products: 'Produits',
  productsPage: {
    changed: 'Le produit a été modifié avec succès',
    changeFailed: "Le produit n'a pas pu être modifié",
    create: 'Créer un produit',
    created: 'Le produit a été créé',
    creationFailed: "Le produit n'a pas pu être créé",
    deleteFailed: "Le produit n'a pas pu être supprimé",
    notFound: 'Produit introuvable',
    removed: 'Le produit a été supprimé avec succès',
    search: 'Trouver un produit...',
    deleteAll: 'Delete all',
    productsDeleted: 'Deleted products',
  },
  provideOwnPincode: 'Ne pas générer automatiquement un code PIN ',
  quotaDetails: {
    title: 'Détails du quota',
    usageLog: "Historique d'usage",
  },
  quotas: {
    lastResetAt: 'Dernière remise à',
    resetsAt: 'Réinitialisation à',
    title: 'Quotas',
    type: 'Type de quota',
    usage: "Quota d'utilisation",
  },
  rawData: 'Données brutes',
  refresh: 'Actualisation',
  refunded: 'Remboursé',
  relatedDocuments: 'Documents liés',
  removeAt: 'Supprimé automatiquement de',
  reservation: 'Réservation',
  reservationActions: {
    boxesRequired: 'Tous les compartiments doivent être sélectionnés',
    cancellationWarning:
      "Voulez-vous vraiment annuler la réservation ? Cette action est irréversible. N'oubliez pas de vider le compartiment.",
    completeReservation: 'Terminer la réservation',
    completeReservationConfirmation: 'Voulez-vous vraiment terminer la réservation ?',
    insufficientBoxes: 'Pas assez de compartiments disponibles',
    orderAmountShouldBeLargerThanZero: 'Le montant de la commande doit être supérieur à zéro',
    reserveBox: 'Réserver un compartiment',
    reserveBoxesForReservation: 'Sélectionner le ou les compartiment(s) à réserver',
    selectABox: 'Sélectionner un compartiment',
    sendNotification: 'Envoyer la notification',
    sendNotificationConfirmation: 'Voulez-vous vraiment envoyer une notification ?',
    shouldSelectALocker: 'Devrait choisir un compartiment',
    showRecentlyOpenedBoxes: 'Afficher les compartiments récemment ouvertes ?',
    toCreated: 'Annuler la réservation de la consigne',
    toCreatedConfirmation: 'Voulez-vous vraiment annuler la réservation de la consigne ?',
  },
  reservationReadyEmailTemplate: "Modèle d'e-mail de notification envoyé lorsque la commande est prête",
  reservationReadySMSTemplate: 'Modèle de SMS de notification envoyé lorsque la commande est prête',
  reservations: 'Réservations',
  reservationScreen: {
    confirmUpdateSentCompleted:
      'Voulez-vous vraiment modifier cette réservation? Une notification a déjà été envoyée, ne changez donc pas le client ou le code PIN pour éviter les problèmes. Cela ne doit être utilisé que pour corriger les erreurs dans les coordonnées.',
    create: 'Créer une réservation',
    createWoyti: 'Créer une réservation woyti',
    createReservation: 'Créer une réservation',
    editReservation: 'Modifier la réservation',
    formTabs: {
      contactDetails: 'Coordonnées',
      extraOptions: 'Options supplémentaires',
      general: 'Généralités',
      vending: 'Woyti',
    },
    hasAlreadyPaid: 'A déjà payé',
    invalidPincode: 'Le code pin doit comporter 4 chiffres',
    noNotificationTypesSelected:
      "Comme aucune notification n'a été sélectionnée, le client ne recevra pas de notification avec le code PIN pour récupérer la commande.",
    noNotificationTypesSelectedTitle: 'Aucun type de notification sélectionné',
    notFound: 'Aucune réservation trouvée',
    notFoundListDescription: 'Aucune réservation trouvée, veuillez modifier les filtres',
    notificationDispatchFailed: "Impossible d'envoyer la notification",
    notificationSent: 'Notification envoyée',
    reservationCreated: 'La réservation a été enregistrée',
    reservationHasChanged: 'La réservation a changé, cliquez sur rafraîchir pour afficher les valeurs mises à jour.',
    reservationInformation: 'Détails de la réservation',
    reservationModified: 'La réservation a bien été modifiée',
    reservationStatusFilter: 'Statut de la réservation',
    search: 'Rechercher une réservation…',
    sendNotificationAt: 'Envoyer la notification à',
    shouldCustomerPay: 'Le client doit-il encore payer ?',
    shouldPay: 'Doit payer',
    statusChanged: 'Le statut a bien été modifié',
    statusChangeFailed: 'Impossible de modifier le statut',
    viewLocker: 'Afficher la consigne',
    woytiNotificationDispatched: 'Notification Woyti envoyée',
    woytiPublished: 'Reservations Woyti publiees',
    woytiNotificationDispatchingFailed: "Échec de l'envoi de la notification Woyti",
    dispatchWoytiNotification: 'Envoyer la notification Woyti',
    dispatchWoytiWithoutNotification: 'Publier les réservations Woyti',
    addDiscountDelay: 'Ajouter une réduction après délai',
    hoursAfterCreation: "Après combien d'heures",
  },
  reservationSettingsScreen: {
    title: 'Reservation Settings',
    shouldCustomerPay: 'Should Customer Pay',
    selectAvailableBoxByDefault: 'Select available box by default',
    changed: 'Reservation settings successfully updated',
  },
  reservationStatusEnum: {
    cancelled: 'Annulé',
    completed: 'Achevé',
    created: 'Créé',
    ordered: 'Commandé',
    reserved: 'Réservé',
    sent: 'Notification envoyée',
  },
  role: 'Rôle',
  save: 'Enregistrer',
  select: 'Sélectionner',
  selectAnOrganisation: 'Sélectionner une organisation',
  sendFeedback: 'Commentaires',
  serverNotifications: {
    noNotifications: 'No notifications right now',
  },
  'service-location': 'Gateway',
  'service-locations': 'Gateways',
  serviceLocationScreen: {
    lastOfflineAt: 'Last Offline',
  },
  serviceLocationsPage: {
    changed: 'Gateway changed',
    changeFailed: 'Could not change gateway',
    create: 'Create gateway',
    created: 'Gateway successfully created',
    creationFailed: 'Gateway could not be created',
    notFound: 'Gateway not found',
    search: 'Find gateway...',
  },
  settings: {
    changed: 'Les paramètres ont été modifiés',
    generalSettings: 'Paramètres généraux',
    email: {
      settings: 'Paramètres email',
      validation: {
        domainRequiresSMTP: 'Vous devez indiquer un serveur SMTP pour tous les domaines autres que %s.',
      },
      customSMTPWarning:
        'Veuillez noter que nous ne pouvons pas garantir la livraison des courriels lorsque vous utilisez un serveur SMTP personnalisé, même si la connexion initiale est validée. Veuillez vous assurer que le serveur SMTP fourni est configuré pour envoyer des courriels en utilisant les paramètres fournis.',
      useCustomSettings: 'Utilisez vos propres paramètres de messagerie',
      fromEmail: "Adresse d'origine ('From: ')",
      smtpServer: 'Serveur SMTP',
      smtpPort: 'Port SMTP',
    },
    payment: 'Paramètres de paiement',
    paymentScreen: {
      connectMollie: "Se connecter à l'aide de Mollie",
      connectMollieAgain: 'Se reconnecter',
      disableTestmode: 'Désactiver le mode test',
      disableTestmodeConfirm: 'Êtes-vous sûr de vouloir désactiver le mode test ?',
      disconnectMollie: 'Disconnect Mollie',
      disconnectMollieConfirm:
        "Are you sure you want to disconnect Mollie, after doing this you won't be able to accept any more payments?",
      enableTestmode: 'Activer le mode test',
      enableTestmodeConfirm:
        'Êtes-vous sûr de vouloir activer le mode test ? Cela permettra aux clients de commander sans payer.',
      gotoMollieDashboard: 'Accéder au tableau de bord Mollie',
      mollieLinked: 'Mollie a bien été lié à votre compte',
      mollieOrganization: 'Mollie Organization',
      mollieOrganizationName: 'Organisation Mollie liée',
      mollieProfile: 'Mollie Profile',
      stillProcessing:
        'Traitement des informations en cours... Veuillez consulter le tableau de bord Mollie pour plus de détails',
      verificationStatus: 'Statut de la vérification',
      verified: 'Vérifié, peut recevoir des paiements',
    },
    virtualVending: 'Woyti settings',
    virtualVendingScreen: {
      findVirtualVendingAt: 'You can find your woyti machine at',
      favoriteCount: 'Woyti nombre de favoris: {count}',
    },
    joyn: {
      title: 'Joyn Settings',
      shopReference: 'Joyn Shop Reference',
      sharedSecret: 'Joyn shared secret',
    },
    qualityGuard: {
      title: 'Paramètres Quality Guard',
      contractId: 'ID du Locataire',
      key: 'Token Secret',
      connectionStatus: 'Statut de connexion',
      checkingConnection: 'Vérification de la connexion...',
      connectionError: 'Échec de la connexion à QualityGuard. Veuillez vérifier vos identifiants.',
      connectionSuccess: '✓ Connexion réussie',
      totalRecipes: 'Total des recettes',
      totalCategories: 'Total des catégories',
      recipeSample: 'Quelques recettes trouvées dans Quality Guard',
      recentProducts: 'Produits récents avec PLU dans Viresmo',
      noProductsWithPLU: 'Aucun produit avec PLU trouvé',
      lastModified: 'Dernière modification',
      active: 'Actif',
      inactive: 'Inactif',
      validated: 'Validé',
      notValidated: 'Non validé',
      allergens: 'Allergènes',
      recipeInfoError: 'Erreur lors du chargement des informations de recette',
      recipeNotFound: 'Recette non trouvée dans QualityGuard',
    },
  },
  settingsPage: {
    changed: 'Les paramètres ont été modifiés',
    updateFailed: 'Impossible de modifier les paramètres',
  },
  severityEnum: {
    danger: 'Danger',
    info: 'Info',
    success: 'Réussi',
    warning: 'Attention',
  },
  shop: 'Boutique',
  shopScreen: {
    create: 'Créer une boutique',
    createdSuccessfully: 'La boutique a été créée',
    heading: 'Boutiques',
    showVirtualVendingInOverview: 'Activer Woyti',
    invalidPickupTime: "L'heure de ramassage n'est pas valide",
    invalidTimeBeforeDispatch: "Le délai avant la confirmation n'est pas valide",
    organisationSettings: "Paramètres de l'organisation",
    overview: "Vue d'ensemble des boutiques",
    search: 'Rechercher des boutiques...',
    timeBeforeConfirmationDispatch: 'Délai avant la notification de confirmation (minutes)',
  },
  sidebar: {
    hide: 'Masquer la barre latérale',
  },
  smsNotification: 'Notification par SMS',
  state: 'Province',
  status: 'Statut',
  street: 'Rue',
  subject: 'Sujet',
  temperature: 'Température',
  testDevice: "Tester l'appareil",
  time: 'Horaire',
  total: 'Total',
  type: 'Type',
  undo: 'Annuler',
  unitEnum: {
    liter: 'Litre',
    kg: 'Kilogramme',
    unit: 'Unité',
  },
  unitAmount: {
    liter: 'Centilitre',
    kg: 'Gramme',
    unit: 'Unité',
  },
  disclaimer: {
    usingAgreeToTerms: 'By using this application you agree to our terms and conditions',
  },
  unitType: 'Unité',
  unknown: 'Inconnu',
  user: 'Utilisateur',
  username: "Nom d'utilisateur",
  userDropdown: {
    changePassword: 'Modifier le mot de passe',
    logout: 'Déconnexion',
    preferences: "Préférences de l'utilisateur",
  },
  userPreferences: {
    title: "Préférences de l'utilisateur",
    updatedSuccess: "Les préférences d'utilisateurs ont été modifiées avec succès",
  },
  usersPage: {
    deleteConfirmation: 'Êtes-vous sûr de vouloir supprimer cet utilisateur ?',
    invite: 'Inviter un nouvel utilisateur',
    inviteSendingFailed: "Impossible d'envoyer l'invitation",
    inviteSent: 'Envoyer une invitation',
    pincodeUpdated: 'Le code PIN a été modifié avec succès',
    pincodeUpdateFailed: 'Impossible de mettre à jour le code PIN',
    sendInvitation: 'Invitation envoyée',
    usersTitle: 'Utilisateurs',
  },
  validation: {
    addressRequired: 'Address is required',
    amountOfBoxes: 'La quantité de boîtes doit être supérieure ou égale à 1',
    boxCount: 'La quantité de boîtes est obligatoire',
    contentRequired: 'Contenu est obligatoire',
    descriptionRequired: 'Description est obligatoire',
    emailRequired: "L'adresse e-mail est obligatoire",
    firstNameRequired: 'Le prénom est obligatoire',
    intervalTooSmall: "L'intervalle doit être supérieur ou égal à 1.",
    invalidEmail: "L'adresse e-mail est invalide",
    invalidName: "Le nom n'est pas valide",
    invalidPhonenumber: "Le numéro de téléphone n'est pas valide",
    language: 'La langue est obligatoire',
    lastNameRequired: 'Le nom de famille est obligatoire',
    locker: 'Le compartiment est obligatoire',
    minimumAmountTooSmall: 'La quantité minimale doit être supérieure ou égale à 1',
    nameRequired: 'Le nom est obligatoire',
    phonenumber: 'Le numéro de téléphone est invalide',
    pickupInFuture: "L'heure d'enlèvement doit se situer dans le futur",
    pickupTimeRequired: "L'heure d'enlèvement est obligatoire",
    priceTooLow: 'Price should be at least 0',
    role: 'Le rôle est obligatoire',
    serviceLocation: 'Gateway is required',
    tinInvalid: 'Le numéro de TVA est invalide',
    tinRequired: 'Le numéro de TVA est obligatoire',
    type: 'Le type est obligatoire',
    vendingProducts: 'La réservation pour woyti doit contenir au moins un produit',
    fieldIsRequired: 'Field may not be empty',
    allergensRequired: 'Veuillez sélectionner au moins un allergène ou "Aucun allergène"',
  },
  vatNumber: 'Numéro TVA',
  vatRate: 'Tarif de la TVA',
  vending: 'Woyti',
  vendingPickupTime: "Délai entre la commande et l'enlèvement (heures)",
  vendingProducts: 'Products in Woyti reservation',
  freeProducts: 'Free product(s)',
  viewAll: 'Tout afficher',
  virtualVendingMachine: 'Woyti',
  zipcode: 'Code postal',
  confirm: 'Confirm',
  webshopUrl: 'Webshop url',
  openingHours: "Heures d'ouverture",
  openingHoursPlaceholder: 'Par ex. Lundi - Vendredi: 9h00 - 18h00, Samedi: 10h00 - 16h00',
  integrations: {
    title: 'Integrations',
    integration: 'Integration',
  },
  autoHideAfterXHours: 'Masquage automatique après x heures',
  defaultAutoHideVendingAfterHours:
    'Masquage automatique par défaut après x heures (peut être modifié par réservation)',
  hours: 'heures',
  validUntil: "Valable jusqu'au",
  validUntilToday: "Valable jusqu'à aujourd'hui",
  validUntilTomorrow: "Valable jusqu'à demain",
  validUntilDayAfterTomorrow: "Valable jusqu'à après-demain",
  validUntilDate: "Valable jusqu'au {date}",
  temperatureLogs: {
    title: 'Journaux de température',
  },
  registeredAt: 'Inscrit à',
};
